import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api } from "../lib/api";
import { apiFail } from "../lib/p2";
import { Btn, Field, Input, Select, Textarea } from "./kit";

const SHORT = ["name", "full_name", "title", "period", "label", "url", "portrait_alt", "key", "essence"];

const blank = (v) => (typeof v === "string" ? "" : Array.isArray(v) ? [] : Object.fromEntries(Object.entries(v || {}).map(([k, x]) => [k, blank(x)])));

function Portrait({ slug, value, onChange, id }) {
  const { t } = useTranslation();
  const up = (f) => {
    const fd = new FormData();
    fd.append("file", f);
    api.post(`/admin/pages/${slug}/portrait`, fd).then((r) => { onChange(r.data.file_id); toast.success(t("b8.portrait_set")); }).catch(apiFail(t));
  };
  return (
    <div className="space-y-2" data-testid={`${id}-portrait`}>
      <label className="flex min-h-[44px] cursor-pointer items-center gap-2 text-sm font-semibold underline">{t("b8.portrait_upload")}<input type="file" accept="image/jpeg,image/png,image/webp" className="sr-only" data-testid={`${id}-portrait-input`} onChange={(e) => e.target.files[0] && up(e.target.files[0])} /></label>
      {value && <p className="text-sm">{t("b8.portrait_set")} <Btn variant="outline" testid={`${id}-portrait-remove`} onClick={() => onChange("")}>{t("b8.portrait_remove")}</Btn></p>}
    </div>
  );
}

function Node({ k, v, onChange, id, slug }) {
  const { t } = useTranslation();
  const base = k.replace(/\s\d+$/, "");
  const label = k ? `${t(`b8.f.${base}`, { defaultValue: base })}${k !== base ? k.slice(base.length) : ""}` : "";
  if (k === "portrait_file_id") return <Portrait slug={slug} value={v} onChange={onChange} id={id} />;
  if (k === "kind") return <Field label={label} htmlFor={id}><Select id={id} data-testid={id} value={v} onChange={(e) => onChange(e.target.value)}>{["linkedin", "instagram", "other"].map((x) => <option key={x} value={x}>{x === "other" ? t("b8.other") : x === "linkedin" ? "LinkedIn" : "Instagram"}</option>)}</Select></Field>;
  if (typeof v === "string" && SHORT.includes(k)) return <Field label={label} htmlFor={id}><Input id={id} data-testid={id} value={v} onChange={(e) => onChange(e.target.value)} /></Field>;
  if (typeof v === "string") return <Field label={label} htmlFor={id}><Textarea id={id} rows={v.length > 160 ? 5 : 2} data-testid={id} value={v} onChange={(e) => onChange(e.target.value)} /></Field>;
  if (Array.isArray(v) && v.every((x) => typeof x === "string")) return <Field label={label} htmlFor={id} hint={t("b8.one_per_line")}><Textarea id={id} rows={Math.max(3, v.length + 1)} data-testid={id} value={v.join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} /></Field>;
  if (Array.isArray(v)) return (
    <fieldset className="space-y-2 rounded-xl border p-3"><legend className="px-1 text-sm font-bold">{label}</legend>
      {v.map((it, i) => <div key={i} className="space-y-2 border-b pb-2"><Node k={`${k} ${i + 1}`} v={it} id={`${id}-${i}`} slug={slug} onChange={(x) => onChange(v.map((y, j) => (j === i ? x : y)))} />
        <Btn variant="outline" testid={`${id}-${i}-remove`} onClick={() => onChange(v.filter((_, j) => j !== i))}>{t("b8.remove_item")}</Btn></div>)}
      <Btn variant="outline" testid={`${id}-add`} onClick={() => onChange([...v, blank(v[0] || "")])}>{t("b8.add_item")}</Btn></fieldset>
  );
  return <div className="space-y-2">{Object.entries(v || {}).map(([kk, x]) => <Node key={kk} k={kk} v={x} id={`${id}-${kk}`} slug={slug} onChange={(nx) => onChange({ ...v, [kk]: nx })} />)}</div>;
}

export function SectionsEditor({ slug, lg, value, onChange }) {
  const { t } = useTranslation();
  const clean = (v) => onChange(v);
  return (
    <details open className="rounded-xl border bg-muted/40 p-3" data-testid={`page-${lg}-sections`}>
      <summary className="cursor-pointer font-semibold">{t("b8.sec_editor")}</summary>
      <div className="mt-3"><Node k="" v={value} id={`sec-${lg}`} slug={slug} onChange={clean} /></div>
    </details>
  );
}
